import { useEffect, useRef } from 'react'
import $ from 'jquery'
import 'daterangepicker'
// import 'daterangepicker/daterangepicker.css' 
import DateRangeIcon from '@mui/icons-material/DateRange'
import './styles.css'
import { InputAdornment, TextField } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import moment from "moment";

export default function DateRangePicker({ label, startDate, endDate, setDateRange, leaveDates, eventDates, minDate, maxDate, disabled, showQuickSelect = false, customRanges, allowWeekends = false }) {
  const { t } = useTranslation()
  const inputRef = useRef(null)
  const pickerRef = useRef(null)

  const toMoment = (date) => {
    if (!date) return moment();
    if (dayjs.isDayjs(date)) return moment(date.toDate());
    return moment(date);
  };

  useEffect(() => {
    $(function () {
      $(inputRef.current).daterangepicker(
        {
          timePicker: false,
          autoApply: true,
          minDate: minDate ? toMoment(minDate) : undefined,
          maxDate: maxDate ? toMoment(maxDate) : undefined,
          startDate: startDate ? toMoment(startDate) : moment(),
          ranges: customRanges ?? (showQuickSelect ? {
            [t('Today')]: [moment(), moment()],
            [t('Yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            [t('Last 7 Days')]: [moment().subtract(6, 'days'), moment()],
            [t('Last 30 Days')]: [moment().subtract(29, 'days'), moment()],
            [t('This Month')]: [moment().startOf('month'), moment().endOf('month')],
            [t('Last Month')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          } : undefined),
          endDate: endDate ? toMoment(endDate) : moment(),
          locale: {
            format: 'MM/DD/YYYY',
          },
          isInvalidDate: date => {
            const dayOfWeek = date.day()
            const d = dayjs(date.toDate());
            return (
              (!allowWeekends && (dayOfWeek === 0 || dayOfWeek === 6)) ||
              leaveDates?.some(leave => dayjs(leave.leaveDate).isSame(d, 'day')) ||
              eventDates?.some(event => dayjs(event.date).isSame(d, 'day'))
            )
          },
          isCustomDate: date => {
            const d = dayjs(date.toDate());
            if (leaveDates?.some((leave) => dayjs(leave.leaveDate).isSame(d, 'day'))) {
              return 'leaveDatesTaken';
            }
            if (eventDates?.some((event) => dayjs(event.date).isSame(d, 'day'))) {
              return 'eventDate';
            }
          },
        },
        function (start, end) {
          setDateRange([dayjs(start.toDate()), dayjs(end.toDate())])
        },
      )

      pickerRef.current = $(inputRef.current).data('daterangepicker');
    })
  }, [minDate, maxDate, leaveDates, eventDates, setDateRange])

  useEffect(() => {
    if (pickerRef.current && startDate && endDate) {
      const startM = toMoment(startDate);
      const endM = toMoment(endDate);

      if (!startM.isSame(pickerRef.current.startDate) || !endM.isSame(pickerRef.current.endDate)) {
        pickerRef.current.setStartDate(startM);
        pickerRef.current.setEndDate(endM);
        $(inputRef.current).val(startM.format('MM/DD/YYYY') + ' - ' + endM.format('MM/DD/YYYY'));
      }
    }
  }, [startDate, endDate]);

  return (
    <TextField
      fullWidth
      inputRef={inputRef}
      type="text"
      size="small"
      label={label || t('Date Range')}
      name="datetimes"
      placeholder="Select a date range"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <DateRangeIcon className="calendar-icon" color="divider" />
          </InputAdornment>
        ),
      }}
      disabled={disabled}
    />
  )
}
